// ─── Plans & paliers — référentiel PARTAGÉ (Core) ─────────────────
// Une seule source pour l'app utilisateur (section « Mon forfait ») et pour
// l'app d'administration (attribution du forfait). Le CONTENU réel de chaque
// plan (palier inclus) vit dans `config/fonctionnalites.plans[plan].palierInclus`,
// réglé depuis MoP Admin — ici on ne décrit que l'ordre et l'identité.
// IDs ALIGNÉS SUR MoPCal : la suite partage la collection `users`, donc le
// champ `plan` d'un compte existant doit rester reconnu (un id inventé rendait
// le forfait courant introuvable — aucune carte sélectionnée dans le profil).
// `horscat` (18/08) : comptes à accès total attribués par l'administration
// SEULEMENT (test, partenaires…) — jamais demandable par un utilisateur, cf.
// le filtre dans SectionMonForfait. En dernier : un utilisateur qui l'a déjà
// le voit toujours (cf. `rangPlan`/tri), mais il ne s'agit pas d'un palier
// supérieur aux forfaits payants — juste hors de leur échelle.
export const PLANS = ['gratuit', 'famille', 'basicplus', 'familleplus', 'horscat'];
// Dupliqué dans `functions/paiement.js` (CommonJS, hors bundle Metro) — les
// deux listes doivent rester alignées à la main si un plan payant change.
export const PLANS_PAYANTS = ['famille', 'basicplus', 'familleplus'];
export const STATUTS = ['en_attente', 'actif', 'suspendu'];
// (les PALIERS et leurs libellés vivent dans fonctionnalites.js — pas de doublon)

export const EMOJI_PLAN = { gratuit: '🌱', famille: '⭐', basicplus: '👪', familleplus: '🚀', horscat: '🔑' };
export const rangPlan = (p) => Math.max(0, PLANS.indexOf(p));

// Demande de changement de forfait déposée par l'utilisateur (le plan lui-même
// n'est modifiable que par l'administration — cf. règles Firestore).
export const aDemandeForfait = (u) => !!u?.planDemande && u.planDemande !== (u.plan || 'gratuit');
